module.exports = __webpack_public_path__ + "img/tutorial_redactions_01.27c7eda8.gif";